module.exports = __webpack_public_path__ + "fonts/17a1468.ttf";